import PropTypes from 'prop-types';
import { graphql, useFragment } from 'react-relay';
import { getFilterValues } from '../sbSharedRefineMenuHelpers.ts';
import { LEAD_TIME_BUCKET_DEFAULT_URLLABEL } from '../sbSharedRefineMenuConstants.ts';

// components
import { SbSharedRefineMenuRadioSelect } from './../SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelect.jsx';
import { SbSharedRefineMenuExpandableItemList } from '../SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList.tsx';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuFilterAvailability_itemSearch on ItemSearchQueryConnection {
        displayUriRef
        appliedFilters {
            name
            values {
                linkReference
                urlLabel
                count
            }
        }
    }
`;

export const SbSharedRefineMenuFilterAvailability = ({
    itemSearch: itemSearchRef,
    filterName,
    shouldUseExpandableList = true,
    values,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const { appliedFilters, displayUriRef } = itemSearch;

    const valuesToShowCopy = [...values];
    const appliedFilterValues = getFilterValues(appliedFilters, filterName);
    const defaultIndex = values.findIndex(
        value => value.urlLabel === LEAD_TIME_BUCKET_DEFAULT_URLLABEL
    );
    const defaultValue = defaultIndex > -1 ? valuesToShowCopy.splice(defaultIndex, 1)[0] : {};

    if (!shouldUseExpandableList) {
        return (
            <SbSharedRefineMenuRadioSelect
                canBeDismissed
                filterName={filterName}
                valuesToShow={valuesToShowCopy}
                displayUriRef={displayUriRef}
                totalCount={defaultValue.count}
                appliedFilterValues={appliedFilterValues}
            />
        );
    }

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={valuesToShowCopy}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuRadioSelect
                    canBeDismissed
                    filterName={filterName}
                    valuesToShow={valuesToShow}
                    displayUriRef={displayUriRef}
                    totalCount={defaultValue.count}
                    appliedFilterValues={appliedFilterValues}
                />
            )}
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbSharedRefineMenuFilterAvailability.propTypes = {
    values: PropTypes.array.isRequired,
    filterName: PropTypes.string.isRequired,
    itemSearch: PropTypes.object.isRequired,
    shouldUseExpandableList: PropTypes.bool,
};
